import { Typography } from 'antd';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import { AIS_MAX_ITEMS_PER_DECLARATION } from 'core/utils/constants';
import { formatProductsTotal } from 'utils/formatProductsTotal';

type Props = {
    open: boolean;
    itemsPriceSum: number | undefined;
    currency: string | undefined;
    onClose: () => void;
    onConfirm: () => void;
};

const BulkUploadItemsCapModal = ({ open, itemsPriceSum, currency, onClose, onConfirm }: Props) => {
    const hasItemsPriceSum = itemsPriceSum !== undefined;

    return (
        <ConfirmationModal
            title="Items Cap"
            confirmButtonText="Continue"
            open={open}
            maskClosable={false}
            onCancel={onClose}
            onClose={onClose}
            onConfirm={onConfirm}
            content={
                <div style={{ paddingInline: 16, marginTop: 8 }}>
                    <Typography>
                        {`This invoice exceeds the ${AIS_MAX_ITEMS_PER_DECLARATION}-item AIS limit. Ddispatch will split it into multiple drafts
                            under the same job. You can review, edit and submit each one as normal.`}
                    </Typography>
                    {hasItemsPriceSum && (
                        <Typography style={{ marginTop: 8 }}>
                            The total amount of the uploaded items is{' '}
                            <strong>{formatProductsTotal(itemsPriceSum, currency)}</strong>.
                        </Typography>
                    )}
                </div>
            }
        />
    );
};

export default BulkUploadItemsCapModal;
